'use client';

import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { GoogleAnalytics } from '@/components/analytics/google-analytics';
import { GoogleAdSense } from '@/components/ads/google-adsense';
import { ConsentBanner } from '@/components/analytics/consent-banner';
import { AnalyticsProvider } from '@/components/analytics/analytics-provider';
import { UpdateAvailableBanner } from '@/components/ui/treina/UpdateAvailableBanner';

export function AppShell({ gaId }: { gaId: string }) {
  return (
    <AnalyticsProvider gaId={gaId}>
      <GoogleAnalytics gaId={gaId} />
      <GoogleAdSense />
      <UpdateAvailableBanner />
      <Toaster position="bottom-center" />
      <Outlet />
      <ConsentBanner />
    </AnalyticsProvider>
  );
}
